<template>
    <div class="dap-multi-select-panel">
        <div class="search-area m-b-10" v-if="filterable && lineable" style="width: 670px;">
            <el-input v-model="search" class="input-with-select f12" :placeholder="placeholder" @keyup.enter.native="handleSearch" size="small">
                <el-button slot="append" icon="el-icon-search" @click="handleSearch"></el-button>
                <slot name="search-prefix" slot="prefix" />
                <slot name="search-prepend" slot="prepend" />
            </el-input>
        </div>
        <div class="select-content f12">
            <div class="content-left" :class="{ 'h292': filterable && !lineable }">
                <div class="search-area m-b-10" v-if="filterable && !lineable">
                    <el-input v-model="search" class="input-with-select f12" :placeholder="placeholder" @keyup.enter.native="handleSearch" size="small">
                        <el-button slot="append" icon="el-icon-search" @click="handleSearch"></el-button>
                        <slot name="search-prefix" slot="prefix" />
                        <slot name="search-prepend" slot="prepend" />
                    </el-input>
                </div>
                <div class="b-999">
                    <div class="left-title p-l-20 f12">
                        <slot name="left-title">
                            <template v-if="!limit">
                                <div class="checkStateBox flex-center" @click="handleChangeCheckState">
                                    <DapIconSvg class="f18"
                                                :class="checkState > 0 ? 'c-blue' : ''"
                                                :iconClass="checkState === 2 ? 'duoxuanxuanzhong' :
                                    checkState === 0 ? 'duoxuanweixuan' : 'duoxuanweiquanxuan'" />
                                </div>
                                <div class="m-l-10 flex-center hand" @click="handleChangeCheckState">
                                    全选
                                    <slot name="select-all-tip" />
                                </div>
                            </template>
                        </slot>
                    </div>
                    <ul class="data-list" ref="dataList">
                        <div class="flex-center c-999" style="height: 100%" v-if="!loading && selfDataList.length === 0">
                            {{listEmptyText}}
                        </div>

                        <li
                            class="f12 flex-normal"
                            :class="{
                                active: isActive(item),
                                'not-allowed': !isActive(item) && (limit === resultList.length)
                            }"
                            v-for="item in selfDataList" :key="item[propsMapper.value]"
                            @click="handleSelect(item)">
                            <i class="m-r-10 flex-center">
                                <DapIconSvg class="f18"
                                            :class="isActive(item) ? 'c-blue' : ''"
                                            :iconClass="isActive(item) ? 'duoxuanxuanzhong' : 'duoxuanweixuan'" />
                            </i>
                            <slot :item="item" name="label">
                                <span class="text-ellipsis inline-block" :title="item[propsMapper.label]">
                                    {{ item[propsMapper.label] }}
                                </span>
                            </slot>
                        </li>

                        <li v-if="loading">
                            <div class="text-center c-999"><i class="el-icon-loading m-r-5"></i>数据加载中</div>
                        </li>
                    </ul>
                </div>
            </div>

            <div class="content-right" :class="{ 'h292': filterable && !lineable }">
                <div class="right-title">
                    <div class="exclude-con">
                        <el-dropdown
                            v-if="showExcludeSelected"
                            class="m-r-10"
                            size="mini"
                            placement="bottom"
                            trigger="click"
                            @command="excludeSelectedChange" >
                            <div class="exclude-dropdown-title f12 fw-400">
                                {{ exclude ? '排除' : '包含' }}
                                <i class="el-icon-arrow-down"></i>
                            </div>
                            <el-dropdown-menu slot="dropdown" >
                                <el-dropdown-item
                                    v-for="item in excludeList"
                                    :key="item.value"
                                    :command="item.value">
                                    <div class="f12 fw-400 lh32">
                                        {{ item.name }}
                                    </div>
                                </el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>

                        <span class="f12">已选：{{ resultList.length }} <span v-if="limit">/ {{limit}}</span></span>
                    </div>
                    <el-button type="text" class="f12" @click="clearAll">清空全部</el-button>
                </div>
                <ul class="item-body" :class="{ 'h252': filterable }">
                    <div class="flex-center c-999" style="height: 100%" v-if="resultList.length === 0">{{resultEmptyText}}</div>
                    <li class="m-t-10 m-b-10" v-for="(item, index) in resultList" :key="index">
                        <slot :item="item" name="result">
                            <span class="inline-block content text-ellipsis" :title="item[propsMapper.label]">
                                {{item[propsMapper.label]}}
                            </span>
                            <i class="el-icon-close c-999 f10 hand" @click="handleRemoveItem(item)"></i>
                        </slot>
                    </li>
                </ul>
                <transition name="el-zoom-in-top">
                    <div class="max-length-tips" v-if="isShowTips">选中数量不能超过{{ maxLenth }}条</div>
                </transition>
            </div>
        </div>
        <div class="m-t-10 text-left" v-if="showTotal">
            <span v-if="remoteSearch">已加载{{ selfDataList.length }}条，</span>共{{ total }}条
        </div>
    </div>
</template>

<script>
import DapIconSvg from "../../icon-svg";

export default {
    name: 'DapMultiSelectPanel',
    components: {
        DapIconSvg,
    },
    provide () {
        return {
            elForm: '',
            elFormItem: '',
        };
    },

    directives: {

    },

    props: {
        dataList: {
            type: Array,
            default: () => []
        },
        resultList: {
            type: Array,
            default: () => []
        },
        propsMapper: {
            type: Object,
            default: () => ({ value: 'value', label: 'label' }),
        },
        filterable: {
            type: Boolean,
            default: true,
        },
        remote: {
            type: Boolean,
            default: false,
        },
        remoteSearch: {
            type: Boolean,
            default: true,
        },
        placeholder: {
            type: String,
            default: '请输入搜索的内容',
        },
        pageSize: {
            type: Number,
            default: 20,
        },
        loadMore: {
            type: Function,
            default: null,
        },
        showTotal: {
            type: Boolean,
            default: true,
        },
        listEmptyText: {
            type: String,
            default: '暂无数据',
        },
        resultEmptyText: {
            type: String,
            default: '暂未选择',
        },
        limit: Number,
        excludeSelected: {
            type: Boolean,
            default: false,
        },
        showExcludeSelected: {
            type: Boolean,
            default: false,
        },
        lineable: {
            type: Boolean,
            default: false,
        },
        maxLenth: {
            type: Number,
            default: 0
        },
    },

    data () {
        return {
            search: '',
            page: 0,
            canLoad: true,
            total: 0,
            selfParams: {},
            selfDataList: [],
            loading: false,
            exclude: false,
            excludeList: [
                { name: '包含', value: false },
                { name: '排除', value: true },
            ],
            remoteSearchList: []
        };
    },

    computed: {
        checkState () {
            if (this.selfDataList.length === 0) return 0;
            const valueList = this.selfDataList.map(i => i[this.propsMapper.value]);
            let num = valueList.length;
            for (let i in this.resultList) {
                if (valueList.includes(this.resultList[i][this.propsMapper.value])) {
                    num -= 1;
                }
            }
            return num === 0 ? 2 : num === this.selfDataList.length ? 0 : 1;
        },

        valueList () {
            return this.resultList.map(i => i[this.propsMapper.value]);
        },

        isShowTips () {
            let state = false;
            if(this.maxLenth) {
                state = this.resultList.length > this.maxLenth;
            }
            return state;
        },
    },

    mounted () {
        this.reset();
    },

    methods: {
        reset () {
            this.search = '';
            this.handleSearch('first');
            this.addScrollListener();
        },

        addScrollListener () {
            const element = this.$refs.dataList;
            element.addEventListener('scroll', e => {
                const target = e.target;
                if (target.scrollTop + target.clientHeight >= target.scrollHeight - 30 && target.scrollHeight > target.clientHeight) {
                    this.handleLoadMore();
                }
            });
        },

        isActive (item) {
            return this.valueList.includes(item[this.propsMapper.value]);
        },

        handleSelect (item) {
            let resultList = [];
            if (this.isActive(item)) {
                resultList = this.resultList.filter(i => i[this.propsMapper.value] !== item[this.propsMapper.value]);
            } else {
                if (this.resultList.length >= this.limit) return;
                resultList = [...this.resultList, item];
            }
            this.$emit('change', resultList);

        },

        clearAll () {
            this.$emit('change', []);
        },

        handleRemoveItem (item) {
            this.$emit('change', this.resultList.filter(i => i[this.propsMapper.value] !== item[this.propsMapper.value]));
        },

        handleChangeCheckState () {
            let resultList = this.resultList;
            if (this.checkState === 2) {
                const dataValueList = this.selfDataList.map(i => i[this.propsMapper.value]);
                resultList = this.resultList.filter(i => !dataValueList.includes(i[this.propsMapper.value]));
            } else {
                this.selfDataList.forEach(item => {
                    if (!this.valueList.includes(item[this.propsMapper.value])) {
                        resultList = [...resultList, item];
                    }
                });
            }
            this.$emit('change', resultList);
        },

        async handleSearch (firstType) {
            // 接口请求 && （第一次加载 || 开启了远程搜索）
            if (this.remote && (firstType === 'first' || this.remoteSearch)) {
                this.page = 1;
                this.total = 0;
                this.selfDataList = [];
                const params = {
                    page: this.page,
                    pageSize: this.pageSize,
                    search: this.search,
                };
                this.loading = true;
                const [res, total] = await this.loadMore(params);
                this.loading = false;
                this.selfDataList = res;
                this.total = total;
                this.remoteSearchList = res;
            } else {
                const dataList = this.remote && !this.remoteSearch ? this.remoteSearchList : this.dataList;
                this.selfDataList = dataList.filter(i => (i[this.propsMapper.value] + '').toLowerCase().includes(this.search.toLowerCase()) || (i[this.propsMapper.label] + '').toLowerCase().includes(this.search.toLowerCase()));
                this.total = this.selfDataList.length;
            }
            this.$refs.dataList.scrollTop = 0;
        },

        async handleLoadMore () {
            if (!this.remote || typeof this.loadMore !== 'function' || (this.page * this.pageSize >= this.total && this.total !== 0 ) || !this.canLoad) {
                return;
            }
            this.canLoad = false;
            this.page = this.page + 1;
            const params = {
                page: this.page,
                pageSize: this.pageSize,
                search: this.search,
            };
            this.loading = true;
            const [res, total] = await this.loadMore(params);
            this.loading = false;
            this.selfDataList = this.selfDataList.concat(...res);
            this.total = total;
            setTimeout(() => { this.canLoad = true; }, 300);
        },

        excludeSelectedChange (val) {
            this.$emit('excludeSelectedChange', val)
        }
    },

    watch: {
        dataList: {
            handler (val) {
                if (val) {
                    this.selfDataList = JSON.parse(JSON.stringify(val));
                    this.total = this.dataList.length;
                }
            },
            deep: true,
            immediate: true,
        },
        excludeSelected : {
            handler (val) {
                this.exclude = val;
            },
            deep: true,
            immediate: true,
        },
    }

};
</script>

<style lang="scss">
$color-blue: #4285F4;

.dap-multi-select-panel {
    font-size: 12px;
    // user-select: none;
    .search-area {
        // width: 670px;
        width: 100%;
        .el-input-group__append {
            width: 30px;
            background-color: #fff;
            box-sizing: border-box;
            padding: 0;
            position: relative;
            .el-button {
                width: 100%;
                height: 100%;
                margin: 0;
                padding: 0;
            }
        }
        .el-input-group__prepend {
            background-color: #fff;
        }
    }

    .select-content {
        display: flex;
        width: 670px;
        justify-content: space-between;
        color: #606266;
        .content-left {
            width: 410px;
            height: 250px;
            // border: 1px solid #E9E9EB;

            .left-title {
                background-color: #F8F8F8;
                height: 40px;
                line-height: 40px;
                display: flex;
                border-bottom: 1px solid #E9E9EB;
                .checkStateBox {
                    cursor: pointer;
                }
            }

            ul.data-list {
                height: 209px;
                overflow-y: auto;
                list-style: none;
                padding: 0;
                margin: 0;

                li {
                    box-sizing: border-box;
                    //width: calc(100% - 10px);
                    height: 38px;
                    line-height: 38px;
                    padding: 0 10px 0 20px;
                    cursor: pointer;

                    .option-row {
                        width: 100%;
                    }

                    &:hover {
                        background-color: #f5f7fa;
                        color: $color-blue;

                        i.fa {
                            color: $color-blue;
                        }
                    }

                    &.active {
                        color: $color-blue;
                    }

                }
                li.not-allowed {
                    cursor: not-allowed;
                }
            }
        }

        .content-right {
            width: 250px;
            height: 250px;
            border: 1px solid #E9E9EB;

            .right-title {
                background-color: #F8F8F8;
                display: flex;
                justify-content: space-between;
                padding: 0 10px 0 6px;
                height: 40px;
                line-height: 40px;
                border-bottom: 1px solid #E9E9EB;

                .exclude-con {
                    .exclude-dropdown-title {
                        background: #FFFFFF;
                        border-radius: 2px;
                        border: 1px solid #E4E7ED;
                        width: 52px;
                        height: 26px;
                        line-height: 24px;
                        padding: 0 4px 0 6px;
                        box-sizing: border-box;
                    }
                }
            }

            .item-body {
                height: 210px;
                padding: 0 10px;
                overflow-y: auto;
                line-height: 12px;
                margin: 0;


                li {
                    box-sizing: border-box;
                    width: 100%;
                    background: #f4f4f5;
                    display: flex;
                    justify-content: space-between;
                    height: 32px;
                    padding: 10px;
                    border-radius: 4px;

                    span {
                        width: auto;
                        font-size: 12px;
                        color: #606266;
                        padding: 0;
                    }
                    i {
                        font-size: 12px !important;
                    }
                }
            }
        }
    }

}
</style>

<style lang="scss" scoped>
.h292 {
    height: 292px !important;
}
.h252 {
    height: 252px !important;
}
.b-999 {
    border: 1px solid #E9E9EB;
}
.max-length-tips {
    font-size: 12px;
    font-weight: 400;
    color: #F56C6C;
}
</style>
